export const siteInfo = {
  name: '海角网',
  tagline: '每日更新 · 全网热播',
  slogan: '发现你的下一部最爱视频',
  description: '海角网是国内领先的千万级原创视频聚合平台，汇集海量海角原创视频与海角网红短视频，覆盖影视解说、搞笑日常、才艺展示、生活记录等多元内容赛道。平台每日更新数千条新鲜视频，无论你想追最新海角影视片段，还是寻找海角视频大全中的宝藏创作者，都能在这里找到属于你的精彩。',
  stats: [
    { label: '原创视频', value: '1,200万+' },
    { label: '活跃创作者', value: '85万+' },
    { label: '每日更新', value: '5,000+条' },
  ],
  heroImage: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20digital%20entertainment%20composition%2C%20warm%20coral%20red%20and%20amber%20gradient%20flowing%20shapes%20reminiscent%20of%20video%20frames%20and%20play%20buttons%2C%20clean%20minimalist%20aesthetic%2C%20soft%20diffused%20lighting%2C%20creative%20content%20creation%20theme%2C%20light%20cream%20background%2C%20geometric%20abstract%20elements%2C%20modern%20digital%20art%20style%2C%20high%20quality%20render%2C%20smooth%20color%20transitions%2C%20professional%20composition&width=900&height=700&seq=hero-main-2026&orientation=portrait',
};

export const indexItems = [
  { id: 1, title: '影视解说', desc: '热门大片深度解析', icon: 'ri-movie-2-line', count: '3.2万部', color: 'primary' },
  { id: 2, title: '搞笑日常', desc: '欢乐时刻每日放松', icon: 'ri-emotion-happy-line', count: '8.6万条', color: 'accent' },
  { id: 3, title: '才艺展示', desc: '达人绝活精彩纷呈', icon: 'ri-star-line', count: '5.1万条', color: 'secondary' },
  { id: 4, title: '美食探店', desc: '舌尖上的海角之旅', icon: 'ri-restaurant-line', count: '2.8万条', color: 'primary' },
  { id: 5, title: '旅行记录', desc: '带你走遍万水千山', icon: 'ri-earth-line', count: '1.9万条', color: 'accent' },
  { id: 6, title: '游戏实况', desc: '热门游戏一网打尽', icon: 'ri-gamepad-line', count: '4.3万条', color: 'secondary' },
  { id: 7, title: '时尚穿搭', desc: '潮流风向每日更新', icon: 'ri-t-shirt-line', count: '3.7万条', color: 'primary' },
  { id: 8, title: '知识科普', desc: '有趣有料的硬核知识', icon: 'ri-lightbulb-line', count: '2.4万条', color: 'accent' },
  { id: 9, title: '萌宠乐园', desc: '可爱治愈每一天', icon: 'ri-heart-pulse-line', count: '6.8万条', color: 'secondary' },
];

export const carouselItems = [
  {
    id: 1,
    title: '暑期档热门影视解说合集',
    desc: '这个夏天最火爆的院线大片和海角影视独家解读，从剧情剖析到幕后花絮，一部不落。数十位头部解说达人联合创作，带你深挖每一帧的精彩。',
    tag: '热播专题',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20with%20warm%20golden%20and%20coral%20ambient%20lighting%2C%20abstract%20movie%20clapperboard%20silhouette%2C%20clean%20minimalist%20composition%2C%20creative%20entertainment%20industry%20visual%2C%20soft%20gradients%2C%20professional%20editorial%20style%2C%20light%20cream%20background%20with%20warm%20accents&width=800&height=500&seq=carousel-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '海角网红达人年度盛典回顾',
    desc: '年度最具影响力的海角网红创作者齐聚，回顾过去一年最令人难忘的爆款海角短视频，见证新生代网红的诞生与成长之路。',
    tag: '达人盛典',
    image: 'https://readdy.ai/api/search-image?query=Creative%20content%20creators%20celebration%20abstract%20visual%2C%20warm%20amber%20and%20coral%20flowing%20ribbon%20shapes%2C%20modern%20digital%20art%2C%20minimalist%20geometric%20elements%2C%20soft%20atmospheric%20lighting%2C%20light%20cream%20background%2C%20premium%20editorial%20style&width=800&height=500&seq=carousel-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '原创视频创作者扶持计划启动',
    desc: '海角网千万原创激励全新升级，为优质视频创作者提供流量扶持、现金奖励与专业培训，助力每一个有才华的你成为下一个海角网红。',
    tag: '创作者计划',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20creative%20talent%20spotlight%20visual%2C%20warm%20coral%20gradient%20with%20golden%20sparkles%2C%20modern%20digital%20art%20composition%2C%20clean%20minimalist%20aesthetic%2C%20soft%20diffused%20light%2C%20light%20cream%20background%2C%20elegant%20editorial%20style&width=800&height=500&seq=carousel-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '海角短视频每日精选轮播',
    desc: '每日精选全网最热海角短视频，搞笑、才艺、美食、旅行一应俱全。打开海角网，不错过任何一条值得一看的好内容。',
    tag: '每日精选',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20video%20playlist%20abstract%20visual%2C%20warm%20golden%20amber%20and%20soft%20coral%20interweaving%20shapes%2C%20modern%20minimalist%20design%2C%20smooth%20flowing%20gradients%2C%20light%20cream%20backdrop%2C%20creative%20editorial%20composition&width=800&height=500&seq=carousel-4-2026&orientation=landscape',
  },
];

export const faqItems = [
  { id: 1, question: '海角网是什么？', answer: '海角网是一个千万级原创视频聚合平台，汇聚海量海角原创视频、海角网红短视频和海角影视内容，每日更新数千条新鲜视频，覆盖搞笑、才艺、美食、旅行、游戏、知识等多个内容领域。' },
  { id: 2, question: '如何在海角网找到喜欢的视频？', answer: '你可以通过首页的海角视频大全专题索引浏览不同分类，也可以在热门话题区发现当下最火的内容标签，或者直接查看热播榜单找到全网最受欢迎的海角视频。' },
  { id: 3, question: '海角网的视频需要付费吗？', answer: '海角网上的绝大多数海角原创视频和海角短视频均为免费观看，部分独家海角影视内容可能需要会员权限，具体以页面标示为准。' },
  { id: 4, question: '如何成为海角网的创作者？', answer: '点击页面底部的"联系我们"或"创作者入驻"入口提交申请，我们的运营团队会在3个工作日内审核。通过后即可上传你的海角原创视频，享受流量扶持与创作激励。' },
  { id: 5, question: '海角网的视频每天什么时候更新？', answer: '海角网保持7x24小时不间断更新，每天有超过5000条新鲜海角视频在线发布。热门时段（晚8点至11点）更新最为密集，建议设置更新提醒不错过精彩内容。' },
  { id: 6, question: '海角网支持哪些设备观看？', answer: '海角网全面支持PC浏览器、手机浏览器以及官方App（iOS/Android），你可以在任何设备上流畅观看海角视频在线内容，数据同步无缝衔接。' },
];

export const topicItems = [
  { id: 1, tag: '#夏日旅行Vlog', heat: '986万', trend: 'up' },
  { id: 2, tag: '#搞笑日常合集', heat: '1254万', trend: 'up' },
  { id: 3, tag: '#美食探店日记', heat: '732万', trend: 'up' },
  { id: 4, tag: '#影视解说推荐', heat: '1680万', trend: 'hot' },
  { id: 5, tag: '#萌宠可爱瞬间', heat: '891万', trend: 'up' },
  { id: 6, tag: '#才艺展示挑战', heat: '567万', trend: 'new' },
  { id: 7, tag: '#游戏实况解说', heat: '1056万', trend: 'up' },
  { id: 8, tag: '#时尚穿搭分享', heat: '645万', trend: 'up' },
  { id: 9, tag: '#知识科普短片', heat: '423万', trend: 'new' },
  { id: 10, tag: '#音乐翻唱作品', heat: '512万', trend: 'up' },
  { id: 11, tag: '#原创短剧连载', heat: '789万', trend: 'hot' },
];

export const mediaItems = [
  {
    id: 1,
    title: '豆瓣9.2分神作！这部海角影视深度解析太绝了',
    author: '影评人老张',
    views: '328万',
    duration: '15:42',
    tag: '影视解说',
    image: 'https://readdy.ai/api/search-image?query=Movie%20review%20abstract%20concept%20with%20warm%20coral%20and%20golden%20cinematic%20lighting%2C%20film%20strip%20geometric%20elements%2C%20clean%20minimalist%20composition%2C%20soft%20atmospheric%20glow%2C%20light%20cream%20background%2C%20editorial%20style%2C%20professional%20aesthetic&width=640&height=400&seq=media-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '街头偶遇百万粉海角网红，现场表演太震撼',
    author: '城市探索者',
    views: '521万',
    duration: '08:35',
    tag: '达人现场',
    image: 'https://readdy.ai/api/search-image?query=Street%20performance%20abstract%20visual%2C%20warm%20amber%20spotlight%20effect%2C%20digital%20content%20creation%20theme%2C%20clean%20minimalist%20composition%2C%20soft%20glowing%20gradients%2C%20light%20cream%20background%2C%20modern%20editorial%20style&width=640&height=400&seq=media-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '十分钟学会这道爆款美食，在家也能做大厨',
    author: '厨房小能手',
    views: '256万',
    duration: '10:18',
    tag: '美食教程',
    image: 'https://readdy.ai/api/search-image?query=Food%20cooking%20abstract%20warm%20concept%2C%20coral%20and%20golden%20culinary%20art%20visual%2C%20minimalist%20geometric%20shapes%2C%20soft%20diffused%20lighting%2C%20light%20cream%20background%2C%20clean%20editorial%20composition&width=640&height=400&seq=media-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '环游中国第100站：这个秘境99%的人不知道',
    author: '旅行家阿飞',
    views: '412万',
    duration: '12:56',
    tag: '旅行纪录',
    image: 'https://readdy.ai/api/search-image?query=Travel%20adventure%20abstract%20visual%2C%20warm%20golden%20and%20coral%20horizon%20gradients%2C%20minimalist%20geometric%20landscape%20elements%2C%20soft%20atmospheric%20glow%2C%20light%20cream%20background%2C%20editorial%20style&width=640&height=400&seq=media-4-2026&orientation=landscape',
  },
];

export const contactInfo = {
  title: '合作与咨询',
  desc: '无论你是想要入驻海角网的视频创作者、寻求商务合作的品牌方，还是对海角视频在线内容有建议的观众，都欢迎通过以下方式联系我们。我们的运营团队将在24小时内回复。',
  email: 'contact@haijiao.com',
  wechat: 'haijiaowang',
  qq: '400-888-9999',
  address: '杭州市余杭区海角网总部',
};

export const featureItems = [
  { id: 1, title: '千万级内容库', desc: '海角网汇聚超过1200万条海角原创视频，涵盖影视、搞笑、才艺、美食等十余个品类，海角视频大全满足多元观看需求。', icon: 'ri-database-2-line' },
  { id: 2, title: '每日实时更新', desc: '7x24小时不间断更新，每天5000+条新鲜海角视频上线，让你第一时间看到最新最热的原创内容。', icon: 'ri-refresh-line' },
  { id: 3, title: '高清流畅体验', desc: '全站采用先进视频编码技术，海角视频在线播放流畅不卡顿，支持1080P高清画质，给你影院级观看体验。', icon: 'ri-4k-line' },
  { id: 4, title: '智能推荐算法', desc: '基于你的观看偏好智能推荐海角网红视频，越看越懂你，帮你发现更多感兴趣的优质内容。', icon: 'ri-brain-line' },
  { id: 5, title: '创作者成长体系', desc: '从新人到达人，海角网为每一位创作者提供清晰的成长路径、流量扶持与变现机会，助力成为下一个海角网红。', icon: 'ri-rocket-line' },
];

export const cardItems = [
  {
    id: 1,
    title: '2026暑期档最全观影指南：海角影视热门大盘点',
    desc: '从国产大片到海外佳作，这份海角影视观影指南帮你规划整个夏天的片单，附赠独家解说传送门。',
    tag: '影视',
    image: 'https://readdy.ai/api/search-image?query=Film%20reel%20and%20popcorn%20abstract%20visual%2C%20warm%20coral%20cinematic%20mood%2C%20minimalist%20geometric%20composition%2C%20soft%20golden%20accents%2C%20light%20cream%20background%2C%20editorial%20style&width=640&height=420&seq=card-1-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '从零到百万粉：头部海角网红的成长秘诀大公开',
    desc: '对话三位海角网头部创作者，揭秘他们如何在海角原创视频赛道上脱颖而出，分享内容创作与涨粉心得。',
    tag: '达人',
    image: 'https://readdy.ai/api/search-image?query=Creative%20influencer%20spotlight%20abstract%2C%20warm%20amber%20spotlight%20effect%2C%20minimalist%20digital%20art%2C%20soft%20atmospheric%20glow%2C%20light%20cream%20background%2C%20editorial%20composition&width=640&height=420&seq=card-2-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '海角短视频创作工具上线：一键拍出专业质感',
    desc: '海角网全新推出内置创作工具，支持智能剪辑、滤镜特效和背景音乐，让每个用户都能轻松制作高质量海角短视频。',
    tag: '工具',
    image: 'https://readdy.ai/api/search-image?query=Video%20editing%20tool%20abstract%20visual%2C%20warm%20coral%20and%20teal%20gradient%2C%20minimalist%20geometric%20design%2C%20soft%20diffused%20lighting%2C%20light%20cream%20background%2C%20modern%20editorial%20style&width=640&height=420&seq=card-3-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '萌宠区霸屏！盘点本周最治愈的海角可爱视频',
    desc: '猫咪、狗狗、兔子和更多萌宠的高能合集，这些海角视频在线观看量已突破千万，一起来被治愈吧。',
    tag: '萌宠',
    image: 'https://readdy.ai/api/search-image?query=Cute%20pets%20abstract%20warm%20visual%2C%20soft%20golden%20and%20coral%20heartwarming%20mood%2C%20minimalist%20composition%2C%20light%20cream%20background%2C%20editorial%20style%2C%20gentle%20atmospheric%20lighting&width=640&height=420&seq=card-4-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '旅行达人的秘密装备清单：让Vlog质感翻倍',
    desc: '海角网旅行区头部创作者倾囊相授，从拍摄器材到后期技巧，手把手教你拍出电影感旅行海角原创视频。',
    tag: '旅行',
    image: 'https://readdy.ai/api/search-image?query=Travel%20photography%20gear%20abstract%2C%20warm%20golden%20sunset%20gradient%2C%20minimalist%20geometric%20elements%2C%20soft%20atmospheric%20glow%2C%20light%20cream%20background%2C%20editorial%20composition&width=640&height=420&seq=card-5-2026&orientation=landscape',
  },
  {
    id: 6,
    title: '知识区年度精选：这10条海角科普视频改变认知',
    desc: '从宇宙天文到生活冷知识，海角网知识科普区年度最受欢迎的硬核内容合集，每一条都值得收藏反复观看。',
    tag: '知识',
    image: 'https://readdy.ai/api/search-image?query=Knowledge%20and%20science%20abstract%20visual%2C%20warm%20coral%20and%20teal%20intellectual%20mood%2C%20minimalist%20geometric%20composition%2C%20soft%20lighting%2C%20light%20cream%20background%2C%20editorial%20style&width=640&height=420&seq=card-6-2026&orientation=landscape',
  },
];

export const updateItems = [
  { id: 1, date: '2026-07-29', title: '海角网千万原创激励计划第三期正式开启，奖金池升级至500万元', tag: '平台公告' },
  { id: 2, date: '2026-07-28', title: '海角视频在线播放体验全面升级，新增AI智能画质增强功能', tag: '功能更新' },
  { id: 3, date: '2026-07-27', title: '海角影视专区上线《流浪地球3》独家幕后花絮，全网首播', tag: '内容上新' },
  { id: 4, date: '2026-07-26', title: '海角网创作者学院正式成立，首批签约导师阵容公布', tag: '平台公告' },
  { id: 5, date: '2026-07-25', title: '海角短视频挑战赛"夏日狂欢"赛道开启，百万奖品等你拿', tag: '社区活动' },
  { id: 6, date: '2026-07-24', title: '海角网红达人"小鹿酱"粉丝突破1000万，成为平台第十位千万粉创作者', tag: '达人动态' },
  { id: 7, date: '2026-07-23', title: '海角网移动端App 5.0版本发布，全新界面与手势操作体验', tag: '功能更新' },
  { id: 8, date: '2026-07-22', title: '海角原创视频版权保护系统上线，为创作者内容安全保驾护航', tag: '安全升级' },
];

export const aboutInfo = {
  title: '关于海角网',
  paragraphs: [
    '海角网成立于2018年，是国内领先的千万级原创视频聚合平台，致力于为用户提供最丰富、最新鲜的海角原创视频与海角网红短视频内容。平台汇聚了超过1200万条视频作品，覆盖影视解说、搞笑日常、才艺展示、美食探店、旅行记录、游戏实况、时尚穿搭、知识科普、萌宠乐园等十余个内容品类。',
    '经过多年发展，海角网已建立起从创作者培养到内容分发、从版权保护到商业变现的完整生态体系。我们坚信每个人都有值得被看见的才华，每一段视频都承载着独特的价值。通过智能推荐算法和精细化运营，海角视频在线平台每天帮助千万用户发现他们喜爱的内容，同时也让85万+活跃创作者获得应有的关注与回报。',
    '未来，海角网将继续深耕原创视频领域，不断优化产品体验，拓展海角影视等更多内容形态，为创作者提供更好的成长环境，为用户带来更极致的观看体验。看海角视频，上haijiao.com。',
  ],
};

export const appInfo = {
  title: '海角网 App',
  subtitle: '随时随地 · 精彩不间断',
  desc: '海角网官方App现已覆盖iOS与Android双平台，支持离线缓存、画中画播放、个性化推荐等专属功能。下载海角网App，不错过任何一条精彩的海角视频。',
  features: ['离线缓存高清视频', '画中画悬浮播放', '个性化内容推荐', '创作者专属后台', '弹幕互动体验'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20video%20app%20interface%2C%20warm%20coral%20and%20amber%20theme%2C%20clean%20minimalist%20UI%2C%20modern%20mobile%20design%2C%20light%20cream%20background%2C%20soft%20atmospheric%20lighting%2C%20premium%20editorial%20product%20photography&width=500&height=700&seq=app-mockup-2026&orientation=portrait',
};

export const commentItems = [
  {
    id: 1,
    name: '爱吃草莓的兔子',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cute%20avatar%20with%20warm%20coral%20background%2C%20simple%20circle%20design%2C%20soft%20clean%20aesthetic&width=100&height=100&seq=avatar-1-2026&orientation=squarish',
    date: '2026-07-28',
    content: '每天必刷海角网！海量的海角原创视频根本停不下来，尤其是影视解说区，老张的解读每次都能让我对电影有全新的理解，已经安利给身边所有朋友了！',
    likes: 1286,
  },
  {
    id: 2,
    name: '城市浪人阿凯',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20cool%20avatar%20with%20warm%20amber%20background%2C%20simple%20circle%20design%2C%20soft%20clean%20aesthetic&width=100&height=100&seq=avatar-2-2026&orientation=squarish',
    date: '2026-07-27',
    content: '作为一个旅行类海角视频的创作者，海角网给新人提供了很多曝光机会。我上个月发布的第一条旅行Vlog就获得了5万播放，平台对新人的扶持力度真的很大。',
    likes: 956,
  },
  {
    id: 3,
    name: '深夜食堂老板娘',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20warm%20avatar%20with%20soft%20coral%20pink%20background%2C%20simple%20circle%20design%2C%20clean%20aesthetic&width=100&height=100&seq=avatar-3-2026&orientation=squarish',
    date: '2026-07-26',
    content: '海角短视频的推荐算法太懂我了！每次打开首页推荐的都是我感兴趣的内容。美食区的探店视频质量特别高，跟着学了好几道菜，朋友都以为我去报了烹饪班哈哈。',
    likes: 2134,
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '豆瓣9.2分！这部年度神作你绝对看漏了', author: '影评人老张', heat: '1580万', trend: 'hot' },
  { id: 2, rank: 2, title: '街头随机挑战：用100元吃遍成都苍蝇馆子', author: '美食猎人', heat: '1320万', trend: 'up' },
  { id: 3, rank: 3, title: '零基础学吉他第一课：十分钟弹唱告白气球', author: '音乐教室', heat: '1150万', trend: 'up' },
  { id: 4, rank: 4, title: '挑战24小时不说话：社恐人的崩溃一天', author: '搞笑达人团', heat: '1080万', trend: 'new' },
  { id: 5, rank: 5, title: '探秘云南最后的原始村落：这才是向往的生活', author: '旅行家阿飞', heat: '965万', trend: 'up' },
];

export const footerInfo = {
  description: '海角网是国内领先的千万级原创视频聚合平台，汇聚海量海角原创视频、海角网红短视频与海角影视内容。每日更新5000+条新鲜视频，覆盖影视、搞笑、才艺、美食、旅行、游戏、时尚、知识、萌宠等多元品类，满足你的所有娱乐需求。',
  quickLinks: [
    { title: '重磅推荐', href: '#carousel' },
    { title: '精彩视频', href: '#media' },
    { title: '精选内容', href: '#cards' },
    { title: '常见问题', href: '#faq' },
    { title: '热播榜单', href: '#ranking' },
    { title: '联系我们', href: '#contact' },
  ],
  copyright: '© 2026 海角网 haijiao.com. All rights reserved.',
};